export class CPPItemsFilter {
  productName: string;
  itemNo: string;
  gtin: string;
  packageSize: string;
  vendor: string;
  activeIngredient: string;
  clearAll: boolean;
  showFavoriteOnly: boolean;
  productLine: string;
  productLineDescription: string;
  shipToOrDeliverToAccount: number;
  productCategory: string;
  productCategoryDescription: string;
}
